module.exports = __webpack_public_path__ + "img/haiying.aed72e7c.jpg";